import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

interface ComboProps {
  label: string,
  options: any,
  handleChange: any,
  value: any
};

export default function ComboBox(props: ComboProps) {
  const { label, options, handleChange, value } = props



  return (
    <Autocomplete
      onChange={handleChange}
      value={value}
      options={options}
      sx={{ width: "100%" }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}